import { TransactionType } from './useTransactions.d';

export const LOADING_TRANSACTIONS = (TYPE: TransactionType) =>
  `LOADING_${TYPE.toUpperCase()}_TRANSACTIONS`;
export const GET_TRANSACTIONS_SUCCESS = (TYPE: TransactionType) =>
  `GET_${TYPE.toUpperCase()}_TRANSACTIONS_SUCCESS`;
export const GET_TRANSACTIONS_ERROR = (TYPE: TransactionType) =>
  `GET_${TYPE.toUpperCase()}_TRANSACTIONS_ERROR`;

export const LOADING_ACTIVE_TRANSACTION = 'LOADING_ACTIVE_TRANSACTION';
export const GET_ACTIVE_TRANSACTION_SUCCESS = 'GET_ACTIVE_TRANSACTION_SUCCESS';
export const GET_ACTIVE_TRANSACTION_ERROR = 'GET_ACTIVE_TRANSACTION_ERROR';
export const CLEAR_ACTIVE_TRANSACTION = 'CLEAR_ACTIVE_TRANSACTION';

export const NEXT_TRANSACTIONS_PAGE = (TYPE: TransactionType) =>
  `NEXT_${TYPE.toUpperCase()}_TRANSACTIONS_PAGE`;
export const PREVIOUS_TRANSACTIONS_PAGE = (TYPE: TransactionType) =>
  `PREVIOUS_${TYPE.toUpperCase()}_TRANSACTIONS_PAGE`;
export const SET_TRANSACTIONS_PAGE = (TYPE: TransactionType) =>
  `SET_${TYPE.toUpperCase()}_TRANSACTIONS_PAGE`;
export const SET_ORDER_REJECTED = (TYPE: TransactionType) =>
  `SET_${TYPE.toUpperCase()}_ORDER_REJECTED`;
export const SET_CONTRACT_CANCELLED = (TYPE: TransactionType) =>
  `SET_${TYPE.toUpperCase()}_CONTRACT_CANCELLED`;
export const LAST_TRANSACTIONS_REACHED = (TYPE: TransactionType) =>
  `LAST_${TYPE.toUpperCase()}_TRANSACTIONS_REACHED`;
export const CLEAR_TRANSACTIONS = (TYPE: TransactionType) =>
  `CLEAR_${TYPE.toUpperCase()}_TRANSACTIONS`;
